import MediaPlanDetails from './MediaPlanDetails';

export default MediaPlanDetails;
